import BatchHistoryApi from '../../../../../api/BatchHistoryApi';
import _ from 'lodash';

export function getList() {
   return BatchHistoryApi.getList()
      .then(response => {
         console.log(response);
         // if (response.success === true) {
         if (response.data.success === true) {
            response.data.data.forEach(el => {
               el.key = el.id;
            });
            console.log(response);
            return response.data;
         }
         else
            throw new Error('Server error');
      })
      .catch(error => {
         throw error;
      });
}

export function getListExtended(page, pageSize, filters) {
   return BatchHistoryApi.getListExtended(page, pageSize, filters)
      .then(response => {
         console.log(response);
         if (response.data.success === true) {
            response.data.data.data.forEach(el => {
               el.key = el.id;
            });
            console.log(response);
            return response.data;
         }
         else
            throw new Error('Server error');
      })
      .catch(error => {
         throw error;
      });
}

export function getItem(itemId) {
   return BatchHistoryApi.getItem(itemId)
      .then(response => {
         console.log(response);
         if (response.data.success === true) {
            return response.data;
         }
         else
            throw new Error('Server error');
      })
      .catch(error => {
         throw error;
      });
}

export function getComplements() {
   return BatchHistoryApi.getComplements()
      .then(response => {
         console.log(response);
         const responseData = {}
         _.forEach(response, (el, i) => {
            if (el.data.success !== true) {
               const error = el.data.error ? el.data.error : 'Server error'
               throw new Error(error)
            }
            responseData[i] = el.data.data;
         });
         return responseData;
      })
      .catch(error => {
         throw error;
      });
}

export function printList(filename, itemIds) {
   return BatchHistoryApi.printList(filename, itemIds)
      .then(response => {
         console.log(response);
         let blob = new Blob([response.data], { type: 'application/*' })
         let link = document.createElement('a')
         link.href = window.URL.createObjectURL(blob)
         link.download = filename;
         link.click();
      })
      .catch(error => {
         throw error;
      });
}